<template>
    <div class="MarketingSites">
		<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
			<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов найдено: {{this.masObjects_total}}</span>
		</div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="marketingSites"
			/>
		</div> 
		<div class="row mx-0 mb-3 align-items-center">
			<div class="bntGroup">
				<base-button type="primary" class="groupfloor" simple @click="GoBack()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
			</div>
					
		</div>

		<card>
			<el-table ref="multipleTable" :data="ApiData" style="width: 100%">				
				<el-table-column
					width="80"
					label="ID"
					property="siteId"
				></el-table-column>
				
				<el-table-column type="expand" >
					<template v-slot="scope">
						<base-radio class="d-block"
							v-for="(el_opt, el_index) in scope.row.mst_data"
							:key="el_opt.siteTermId+'_'+el_opt.siteId+'_'+el_opt.type+'_'+el_index"
							:name="el_opt.siteTermId"
							v-model="objChosenTP[scope.row.siteId].choise"
							@input="onChangeTP(el_opt,scope.row.siteId,objChosenTP[scope.row.siteId].choise)"
							inline
						>{{el_opt.name}} - Cтоимость: {{ el_opt.price }} руб.</base-radio>
					</template>
				</el-table-column>

				<el-table-column
				label="Настройка выгрузки"
				min-width="200"
				prop="name">
				</el-table-column>

				<el-table-column
				label="Телефон"
				prop="contact"
				min-width="200">
					<template v-slot="scope">
						<div class="row">
							<div class="col-md-12">
								
								<ReInputContactSimple
									v-model="objChosenTP[scope.row.siteId].phone" 
									:contactGroup_options="contactGroup_options"
									contactGroup="phone"
									:disableByOptId="'1'"
								/>
								
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column
				label="Фид или не фид"
				prop="feed"
				min-width="70">
					<template v-slot="scope">
						<template v-if="scope.row.feed==0">
							Прямая подача
						</template>
						<template v-if="scope.row.feed==1">
							Фид 
						</template>
						
					</template>
				</el-table-column>
				<el-table-column
					width="170"
					label="Действие"
					align="right"                    	
				>
					<template v-slot="scope">	
						<base-switch
							v-model="objChosenTP[scope.row.siteId].act"
							offText="Выкл"
							onText="Вкл"
							type="primary"
						></base-switch>
					</template>
				</el-table-column>
			</el-table>

			<p class="description mt-4">Общая стоимость: <b>{{ itogBet }} руб.</b></p>

			<div class="mb-1 text-center">
				<base-button @click="SaveChanges()" type="success" simple>Сохранить</base-button>
			</div>
		</card>
    </div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
import { BaseSwitch, BaseRadio } from 'src/components/index';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import Pagination from 'src/our_components/RePagination';
import ReInputContactSimple from "src/our_components/ReInputContactSimple.vue";

export default {
	name: 'MarketingSites-page',
	components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    ReFilterBtn,
    ReFilter,
    // Pagination,
    BaseSwitch,
    BaseRadio,
    ReInputContactSimple,
},
	data() {
		return {
			// let result_id = typeof this.$route.params.plan_id=='undefined'?null:this.$route.params.plan_id;
			ApiData: [],
			objGetParams:{},
			masObjects_total: 0,
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			objChosenTP:{},
			itogBet: 0,
			contactGroup_options: [{"value":"0","label":"Компания"},{"value":"1","label":"Агент"}],
		};
	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall('marketing_sites.GET',{flt:{'plan_id':this.$route.params.plan_id}})
			.then((objApi) => {
				let choise, selPrice;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						for (let i = 0; i < this.ApiData.length; i++) {

							choise = this.ApiData[i].choise;
							selPrice = 0;
							for(let term of this.ApiData[i].mst_data){
								if(term.siteTermId == choise){
									selPrice =  term.price;
									break;
								}
							}

							this.$set(this.objChosenTP, this.ApiData[i].siteId, {
								'act':this.ApiData[i].act,
								'choise':this.ApiData[i].choise.toString(),
								'bet': this.ApiData[i].bet,
								'selPrice': selPrice, 
								'phone':{"contact_id":"","contact_type":this.ApiData[i].contact_group.toString(),"contact_value":this.ApiData[i].phone,"contact_view":"","contact_group":"phone"}
							});

						}
						this.$refs.multipleTable.doLayout();
						this.updatePrice();
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('marketing_sites.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
						eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){ 
			//console.log('OnFilterApply_caller',new Error().stack);
			//console.log('OnFilterApply',data);

			let bFromObj = false;
			
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
				delete this.objGetParams['p'];
			}

			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
					if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
				}
			}
			
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',location.pathname+'?'+strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			
		},
		SaveChanges(){
			// let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			// console.log('this.objGetParams',this.objGetParams);
			this.$GVO.ApiCall('marketing_sites.save_sites',{flt:{'plan_id':this.$route.params.plan_id},iData:{...this.objChosenTP}})
			.then((objApi) => {
				if(objApi.success === true){
					// this.$router.push({path: location.pathname+'?'+strItogGetParams});
					
					this.$router.push({path: '/data/module/mo/marketing_plan'});
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		onChangeTP(data,siteId){
			this.objChosenTP[siteId].selPrice = data.price;

			this.updatePrice();
		},
		updatePrice(){
			let price = 0
			for (const key in this.objChosenTP) {
				if (Object.hasOwnProperty.call(this.objChosenTP, key)) {
					price += this.objChosenTP[key].selPrice;
				}
			}
			this.itogBet = price;
		},
		GoBack(){
			this.$router.back();
		},
	},		
	mounted(){
		// console.log('произошел mounted');
		this.objGetParams = this.$GVO.GetAllGet();
		this.getApiData();
	}
};
</script>
<style scoped>

/* .MarketingSites .bootstrap-switch {
    width: 90px!important;
} */
</style>
